import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { string, func, object } from 'prop-types'
import { FieldDetection } from '@components'

export const BaseValidation = ({ type = string, validation = {}, onChange = () => {} }) => {
  const optFieldIsString = opt => opt.field_type === 'string'
  const getValidationOptions = option => validation?.options[option.slug]
  const searchForValidationMetadata = validationOptions =>
    Object.values(validationOptions?.metadata || [])[0]

  return (
    <div style={{ width: '100%' }}>
      {type.options?.map((opt, index) => {
        return (
          <>
            {index !== 0 ? <Divider style={{ marginTop: 12, marginBottom: 36 }} /> : null}
            <div style={{ width: '100%', display: 'inline-flex' }}>
              <div style={{ width: '33%' }}>
                <FieldDetection
                  key={opt.slug}
                  onChange={val => {
                    onChange({
                      slug: type.slug,
                      name: type.name,
                      description: type.description,
                      ...validation,
                      options: {
                        ...validation?.options,
                        [opt.slug]: { ...opt, enabled: val, metadata: { [opt.slug]: val } },
                      },
                    })
                  }}
                  type={opt.field_type}
                  label={opt.name}
                  slug={opt.slug}
                  value={
                    optFieldIsString(opt)
                      ? searchForValidationMetadata(getValidationOptions(opt))
                      : getValidationOptions(opt)?.enabled || getValidationOptions(opt)?.value
                  }
                />
              </div>
              <div style={{ width: '67%' }}>
                <Typography variant="subtitle2">WHAT DOES THIS DO?</Typography>
                <Typography align="left" variant="body2">
                  {opt.description}
                </Typography>
              </div>
            </div>
          </>
        )
      })}
    </div>
  )
}

BaseValidation.propTypes = {
  validation: object,
  type: string,
  onChange: func,
}
